import {
  mapTeamType,
  mapUserType,
  TeamType,
  UserType,
  useFindTaskAssignableTeamsSuspense,
  useFindTaskAssignablePersonsSuspense,
} from '@api';

type UseTaskAssignablesSuspenseReturnType = {
  assignableUsers: UserType[];
  assignableTeams: TeamType[];
};

export const useTaskAssignablesSuspense =
  (): UseTaskAssignablesSuspenseReturnType => {
    const { data: assignableUsers } = useFindTaskAssignablePersonsSuspense({
      query: {
        select: (response) => response.data.map(mapUserType),
      },
    });
    const { data: assignableTeams } = useFindTaskAssignableTeamsSuspense({
      query: {
        select: (response) => response.data.map(mapTeamType),
      },
    });

    return {
      assignableUsers,
      assignableTeams,
    };
  };
